module.exports = __webpack_public_path__ + "static/gasper-130bc868e8c8e9b470949d036b00d451.png";